import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import {provideRouter} from '@angular/router';
import { AppComponent } from './app/app.component';
import {AppShellComponent} from './app/app-shell.component';
import {BcbPageComponent} from './app/bcb/bcb-page.component';

bootstrapApplication(AppShellComponent, {
  providers: [
    provideHttpClient(),
    provideRouter([
      {path: '', component: AppComponent},
      {path: 'bcb', component: BcbPageComponent},
      {path: '**', redirectTo: ''},
    ]),
  ],
}).catch((error: unknown) => console.error(error));
